import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import Results from './Results';
import SearchFilter, {FilterValues} from './SearchFilter';
import {BillingPartyMember} from '../../../graphql/billing_party.datatypes';
import getBillingPartyMembers from './getBillingPartyMembers.api';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    results: {
        marginTop: theme.spacing(3)
    }
}));

export const initialFilters: FilterValues = {};

export const BillingPartyPayingMembersListContent = (props: {
    userId?: number,
    bookingId?: number,
    isAdmin: boolean,
    canEdit: boolean,
    selectedBillingPartyMember?: BillingPartyMember,
    setSelectedBillingPartyMember?: (member: BillingPartyMember) => void,
}) => {
    const {isAdmin, canEdit, selectedBillingPartyMember, setSelectedBillingPartyMember} = props;
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = useState(1);
    const [orderBy] = useState([{column: 'created_at', order: 'DESC'}]);

    const [filters, setFilters] = useState(initialFilters);

    const addWhereUserId = (constraints: WhereConstraints) => {
        const whereConstraints = {...constraints}
        if (props.userId) {
            whereConstraints.AND = [
                {column: 'user_id', operator: OPERATOR.EQ, value: props.userId},
            ]
        }
        return whereConstraints;
    }

    const applyFilters = (newFilters: FilterValues) => {
        setFilters(newFilters);
        setWhere(getConstraintsFromFilters(newFilters));
    };

    const getConstraintsFromFilters = (newFilters: FilterValues) => {
        let whereConstraints: WhereConstraints = {
            AND: [],
        };

        whereConstraints = addWhereUserId(whereConstraints)
        return whereConstraints;
    };

    const [where, setWhere] = useState(getConstraintsFromFilters(initialFilters));

    const billingPartyMembersData = getBillingPartyMembers(rowsPerPage, page, where, orderBy);
    const billingPartyMembers = billingPartyMembersData.data && billingPartyMembersData.data.billingPartyMembers;

    const handleSearch = (value: string) => {
        const whereConstraints: WhereConstraints = {};
        setFilters(initialFilters);
        setWhere(whereConstraints);
    };

    return (
        <React.Fragment>
            <SearchBar filterContent={
                <SearchFilter filters={filters} initialFilters={initialFilters} applyFilters={applyFilters}/>
            }
            />
            <LoadingOverlay loading={billingPartyMembersData.loading}>
                {billingPartyMembers && billingPartyMembers.data && (
                    <Results
                        className={classes.results}
                        billingPartyMembers={billingPartyMembers.data}
                        paginatorInfo={billingPartyMembers.paginatorInfo}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        selectedBillingPartyMember={selectedBillingPartyMember}
                        setSelectedBillingPartyMember={setSelectedBillingPartyMember}
                    />
                )}
            </LoadingOverlay>
        </React.Fragment>
    );
};

const BillingPartyPayingMembersList = () => {
    const classes = useStyles();
    const title = 'Billing Parties';

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="groups" title={title}/>
            <BillingPartyPayingMembersListContent isAdmin={true} canEdit={true}/>
        </Page>
    );
};

export default BillingPartyPayingMembersList;
